import { getParentOfType, Instance, types } from 'mobx-state-tree';

import { UpgradeComponentInfo } from '../../starter-kit-selection/model/UpgradeComponentInfo';
import { ErKitStore } from './ErKitStore';

export const EssentialRewardKit = types
  .model({
    itemId: types.identifierNumber,
    partNumber: types.string,
    description: types.maybe(types.string),
    smallImageUrl: types.optional(types.string, ''),
    largeImageUrl: types.optional(types.string, ''),
    title: types.maybe(types.string),
    listItems: types.array(types.string),
    details: types.array(types.string),
    price: types.number,
    pointValue: types.number,
    isAutoShipAvailable:types.optional(types.boolean,false),
    upgradeComponent: types.maybeNull(UpgradeComponentInfo)
  })
  .views(self => ({
    isSelected(): boolean {
      return getParentOfType(self, ErKitStore).selectedKit === self;
    }
  }));
export type EssentialRewardKit = Instance<typeof EssentialRewardKit>;
